"use client";

import React, { forwardRef, useEffect } from "react";
import TitleCurrencyListItem from "../currencyListItems/titleCurrencyListItem";
import CurrencyListItem from "../currencyListItems/currencyListItem";
import styles from "./currencyDropdown.module.scss";
import getFlagUrl from "@JohnLewisPartnership/jlfs-ui-library/dist/utils/getFlagUrl";
import { MappedFresCurrency } from "../../../../utils/getFresCurrencies/getFresCurrencies";

export type TCurrencyDropdownProps = {
  currencyList: Array<MappedFresCurrency>;
  handleClick?: (event: any) => void;
  handleListItemClick?: (event: any) => void;
  setDropdownIsOpen?: (value: boolean) => void;
};

function CurrencyDropdown(
  {
    currencyList,
    handleListItemClick,
    handleClick,
    setDropdownIsOpen,
  }: TCurrencyDropdownProps,
  ref: React.ForwardedRef<HTMLUListElement>
) {
  useEffect(() => {
    handleClick && document.addEventListener("mousedown", handleClick);
    return () => {
      handleClick && document.removeEventListener("mousedown", handleClick);
    };
  });

  const handleKeyDown = (event: React.KeyboardEvent<HTMLUListElement>) => {
    const currentElement = document.activeElement;
    if (event.key === "ArrowDown") {
      event.preventDefault();
      const nextElement = currentElement?.nextElementSibling as HTMLElement;
      nextElement?.focus();
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      const previousElement = currentElement?.previousElementSibling as HTMLElement;
      previousElement?.focus();
    } else if (event.key === "Enter") {
      event.preventDefault();
      (currentElement as HTMLElement)?.click();
    } else if (event.key === "Escape") {
      event.preventDefault();
      setDropdownIsOpen && setDropdownIsOpen(false);
    }
  };

  return (
    <ul
      className={styles.dropdown}
      data-testid="currency-list"
      role="menu"  
      aria-label="Currency List"
      ref={ref}
      onKeyDown={handleKeyDown}
    >
      <TitleCurrencyListItem
        title="Select Currency"
        removeTopBorder
      ></TitleCurrencyListItem>
      {currencyList.map((rate, index) => (
        <CurrencyListItem
          currencyName={`${rate.currencyName} (${rate.currencyCode})`}
          flagSrc={getFlagUrl(rate.countryCode ?? "")}
          key={rate.currencyCode}
          itemIndex={index}
          itemType="popular"
          clickHandler={handleListItemClick}
        ></CurrencyListItem>
      ))}
    </ul>
  );
}

export default forwardRef(CurrencyDropdown);